import React, { Component, Fragment } from 'react';
import { Link } from "react-router-dom";
import PDF from 'react-pdf-js'
// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import '../../../assets/css/accordion-arrow-fancy.css'
import { _delete, get, postWithHeaders, postWithHeadersResponse, put } from "../../../server/actions";
import { MONTH, currency_symbol, URL_VERSION, menuTypeCalender, MenuOrderTypes, date_format } from "../../../server/constants";
import { text2num } from '../../../server/word2number'
import {
    _addNotification, _addNotificationError, buildGradeName,
    formatDate, standardDateFormat, convertUTCDateToLocalDate, gradeTextToNumber, getSchoolGrades, groupBy, getNotWorkingDays, getSalesTaxRate, numberParce
} from "../../../server/util";
import ReactTable from 'react-table'
import '../../../../src/assets/css/react-table.css'
import Datetime from 'react-datetime'
import Modal from 'react-modal'
import NotificationSystem from 'react-notification-system'
import { BeatLoader } from 'react-spinners'
import PropTypes from "prop-types";
import $ from "jquery";
import '../../../assets/css/fullcalendar.css'
import '../../../assets/css/fullcalendar.min.css'
import 'react-big-calendar/lib/less/month.less'
import '../../../assets/css/react-big-calendar.css'
import 'react-big-calendar/lib/less/styles.less'
import { MealTypes } from '../../../server/constants';
import moment from 'moment';
import Toggle from 'react-toggle';
import ManageMealItemCal from './manageMealItemCal';
import ManageExtraItemCal from './managaExtraItemCal';
import { getModuleEnum, getAccessLevelByModule, sortGrade, isWeekMenu, isRegularLunchOrderType, getSalesTaxStatus } from '../../../server/util';
import CutoffDays from './cutoffDays';
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import { setSchoolYearSettingsToSession } from './../ManageSchools/manageSchoolSettings'
var _ = require('lodash');
let editMenu = {};
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
const disableStyle = {
    pointerEvents: 'none',
    cursor: 'not-allowed',
    color: 'gray'
}
const modEnum = getModuleEnum();
let gradeList = [];
class viewMenuV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLunch: getAccessLevelByModule(modEnum.LMCU) ? true : (getAccessLevelByModule(modEnum.BMCU) ? false : (getAccessLevelByModule(modEnum.SMCU) ? false : null)),
            breakfastTableData: [],
            tableData: [],
            error: false,
            cutOffDateTime: '',
            meals: [],
            loading: false,
            modalIsOpen: false,
            extraItemStatus: null,
            mealSummaryId: '',
            orderDateExtensionStatus: false,
            isSideSelect: false,
            extraEnableForCaterer: false,
            autoReminderDate1: null,
            autoReminderDate2: null,
            cutOffType: isWeekMenu((getMenuOptions()[0] || '')) ? 'W' : 'M',
            weeklyOrderCutOffDay: '',
            weeklyOrderCutOffTime: '23:59',
            allowOrderNDaysTimeBefore: '23:59',
            allowOrderNDaysBefore: 0,
            publishModalIsOpen: false,
            publishRow: {},
            unpublishModalIsOpen: false,
            unpublishRow: {},
            regenPdfModelIsOpen: false,
            regenRecord: {},
            mealType: (getMenuOptions()[0] || ''),
            isExtraPreOrder: false,
            expanded: {},
            showDeleteModal: false,
            deleteRec: {},
            reducedPriceModal: false,
            reducedPriceLoading: false

        }
        this.handleUpdate = this.handleUpdate.bind(this);
        this.edit_publishMenu = this.edit_publishMenu.bind(this);
        this.publishMeal = this.publishMeal.bind(this);
        this.regenerateMealPDF = this.regenerateMealPDF.bind(this);
        this.callBackManageItems = this.callBackManageItems.bind(this);
        this.renderInput = this.renderInput.bind(this);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;

    };
    componentWillMount = () => {
        let date = new Date();
        let year = date.getFullYear();
        this.loadData(year);
    }
    loadData = (year) => {
        let schoolYearsList = JSON.parse(sessionStorage.getItem('schoolYearsList'))
        let selectedSchoolYear = _.filter(schoolYearsList, function (o) {
            return o.schoolYear == sessionStorage.getItem('schoolYearValue')
        });
        console.log('selectedSchoolYears', selectedSchoolYear)
        if (selectedSchoolYear.length > 0) {
            let startYearMonth = moment(selectedSchoolYear[0].sessionStartDateTime).local().format('YYYYMM')
            let endYearMonth = moment(selectedSchoolYear[0].sessionEndDateTime).local().format('YYYYMM')
            // get('/schoolMeals/search/mealMenuPdfByMealSchoolIdAndYear?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&year='+sessionStorage.getItem('schoolYearValue')+'&access_token=').then((response) => {
            this.setState({ loading: true });
            //const mType=(this.state.mealType===MealTypes.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.state.mealType;
            get(`/monthlyCalendars/${sessionStorage.getItem('SchoolId')}/${this.state.mealType}?startYearMonth=${startYearMonth}&endYearMonth=${endYearMonth}&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                console.log("Orders of student returned", data)
                const pdfFIles = JSON.parse(JSON.stringify(data)); //data._embedded.mealCalendarSummaries;
                const months = [];
                pdfFIles.forEach(file => {
                    if (months.indexOf(file.yearMonth) < 0) {
                        months.push(file.yearMonth)
                    }
                });
                const final = [];
                const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
                months.map(month => {
                    (pdfFIles.filter(rec => rec.yearMonth == month)).map(file => {
                        const _obj = {};
                        _obj.monthNumber = month;
                        _obj.month = moment(month, 'YYYYMM').format('MMMM YYYY')
                        _obj.cutoff = file.cutOffTzDateTime;
                        _obj.cutOffDateTime = file.cutOffTzDateTime;
                        _obj.cutOffType = file.cutOffType;
                        _obj.weeklyOrderCutOffDay = file.weeklyOrderCutOffDay;
                        _obj.weeklyOrderCutOffTime = file.cutOffType == 'W' ? file.weeklyOrderCutOffTime : '23:59';
                        _obj.allowOrderNDaysTimeBefore = file.cutOffType == 'R' ? file.weeklyOrderCutOffTime : '23:59';
                        _obj.allowOrderNDaysBefore = file.allowOrderNDaysBefore;
                        _obj.grades = (file.grades || []).map(gVal => {
                            return ((gradeGroup[gVal] || [])[0] || {}).label || gVal
                        }).join(',');
                        _obj.pdf = file.pdfLink;
                        _obj.orderDateExtensionStatus = file.orderDateExtensionStatus;
                        _obj.isSideSelect = (file.isSideSelect || false);
                        _obj.extraEnableForCaterer = (file.extraEnableForCaterer || false);
                        _obj.isExtraPreOrder = (file.isExtraPreOrder || false);
                        _obj.autoReminderDate1 = file.autoReminderDate1;
                        _obj.autoReminderDate2 = file.autoReminderDate2;
                        _obj.isPublished = file.isPublished;
                        _obj.name = file.name;
                        _obj.id = file.id;
                        _obj.hideWeekEnds = file.hideWeekEnds;
                        _obj.salesTaxPerc = getSalesTaxRate();
                        final.push({ ..._obj });
                    })
                })
                console.log('final:', final);
                this.setState({
                    tableData: final
                        .sort((a, b) => {
                            if (Number(a.id) < Number(b.id)) {
                                return 1;
                            }
                            if (Number(a.id) > Number(b.id)) {
                                return -1;
                            }
                            return 0;
                        }), loading: false
                })
            })
                .catch(
                    (error) => {
                        console.log('Get orderlist response', error)
                        this.setState({ tableData: [], loading: false })
                    }
                )
        }
    }
    cutOffChange = (e) => {
        this.setState({ cutOffDateTime: new Date(e) })
    };
    openModal = (data) => {
        this.setState({
            cutOffDateTime: new Date(data.cutoff),
            orderDateExtensionStatus: data.orderDateExtensionStatus,
            isSideSelect: (data.isSideSelect || false),
            isExtraPreOrder: (data.isExtraPreOrder || false),
            salesTaxPerc: data.salesTaxPerc || 0.00,
            extraEnableForCaterer: (data.extraEnableForCaterer || false),
            autoReminderDate1: data.autoReminderDate1,
            autoReminderDate2: data.autoReminderDate2,
            cutOffType: data.cutOffType,
            weeklyOrderCutOffDay: data.weeklyOrderCutOffDay,
            weeklyOrderCutOffTime: moment(data.weeklyOrderCutOffTime, 'HH:mm'),
            allowOrderNDaysTimeBefore: moment(data.allowOrderNDaysTimeBefore, 'HH:mm'),
            allowOrderNDaysBefore: data.allowOrderNDaysBefore
        });
        editMenu.mealSummaryId = data.id //data._links.self.href.split('/').pop();
        this.setState({ modalIsOpen: true });
    };
    handleUpdate = (respObj) => {
        if (respObj.cutOffType == 'W') {
            editMenu.cutOffType = respObj.cutOffType;
            editMenu.weeklyOrderCutOffDay = respObj.weeklyOrderCutOffDay;
            editMenu.weeklyOrderCutOffTime = respObj.weeklyOrderCutOffTime.format('HH:mm');
            editMenu.allowOrderNDaysBefore = 0
            editMenu.cutOffDateTime = null;

        } else if (respObj.cutOffType == 'R') {
            editMenu.allowOrderNDaysBefore = respObj.allowOrderNDaysBefore;
            editMenu.weeklyOrderCutOffDay = '';
            editMenu.weeklyOrderCutOffTime = respObj.allowOrderNDaysTimeBefore.format('HH:mm');;
            editMenu.cutOffType = respObj.cutOffType;
            editMenu.cutOffDateTime = null;
        } else {
            let d1 = new Date(respObj.cutOffDateTime);
            let d2 = new Date(respObj.cutOffDateTime);
            editMenu.orderDateExtensionStatus = respObj.orderDateExtensionStatus;
            editMenu.cutOffType = respObj.cutOffType;
            editMenu.weeklyOrderCutOffDay = '';
            editMenu.weeklyOrderCutOffTime = '23:59';
            editMenu.cutOffTzDateTime = moment(respObj.cutOffDateTime).isValid() ? moment(respObj.cutOffDateTime).format('YYYY-MM-DD HH:mm:ss') : null;
            if (respObj.autoReminderDate1) {
                editMenu.autoReminderDate1 = formatDate(new Date(d1.setDate(d1.getDate() - 7)))
            }
            if (respObj.autoReminderDate2) {
                editMenu.autoReminderDate2 = formatDate(new Date(d2.setDate(d2.getDate() - 2)))
            }
        }
        editMenu.isSideSelect = respObj.isSideSelect;
        editMenu.isExtraPreOrder = (respObj.isExtraPreOrder || false),
            editMenu.salesTaxPerc = numberParce(respObj.salesTaxPerc);
        editMenu.extraEnableForCaterer = respObj.extraEnableForCaterer;
        let headers = {
            'Content-Type': 'application/json'
        };
        //publish field is not required for update meal
        let editMenuObj = Object.assign({}, editMenu);
        delete editMenuObj.isPublished;
        postWithHeaders(URL_VERSION + '/updateMealSummary?access_token=', JSON.stringify(editMenuObj), headers).then((response) => {
            this.setState({ loading: true });
            if (response.status === 200) {
                this.setState({ loading: false, modalIsOpen: false });
                _addNotification('Successfully Updated Cut-off Date.', this);
                let promise1 = new Promise((resolve, reject) => {
                    if (getSalesTaxStatus()) {
                        setSchoolYearSettingsToSession(sessionStorage.getItem('SchoolId'));
                    } else {
                        resolve(true);
                    }
                });
                let promise2 = new Promise((resolve, reject) => {
                    this.loadData((new Date()).getFullYear());
                });
                Promise.all([promise2, promise1])
                    .then((result) => {
                    });
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false, modalIsOpen: false });
                _addNotificationError('Failed to Update Try Again!', this);
            }
        );
    }
    loadMenu = (row) => {
        let id = row.original.id//row.original._links.self.href.split('/').pop();
        get('/mealSummaryDetails?menuSummaryId=' + id + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {

            this.setState({ extraItems: data.isExtraPreOrder })

        }).catch(error => {
            console.log("Loading Menu Failed", error)
        })
    }
    eventStyles = (event, element, view) => {
        if (event.type === "MEAL") {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                + event.title + "  " + currency_symbol() + event.price + '</div>');
            //event.color = "#FFB347"; //Em andamento
        }
        else if (event.type === "SIDE") {
            event.start = event.start + (1 * 60 * 60 * 1000);
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', 'red');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px');
        } else if (event.type === "MEAL") {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: green;font-size: 13px;font-weight: bolder">'
                + event.title + "  " + currency_symbol() + event.price + '</div>');
            //event.color = "#FFB347"; //Em andamento
        }
    }


    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }

    callBackManageItems = () => {
        this.loadData(parseInt(moment().format('YYYY')))
    }

    edit_publishMenu(row, action, mealType) {
        if (action === 'EDIT') {
            let menuId = row.id;//row._links.self.href.split('/').pop();
            this.props.readSchoolMealId(menuId, mealType);
            this.props.history.push('/schoolAdmin/editMenu');
        } else if (action === 'NEW') {
            this.props.readSchoolMealId(0, mealType);
            this.props.history.push('/schoolAdmin/createMenu');
        }
        else if (action === 'UNPUBLISH') {
            this.setState({ unpublishModalIsOpen: true, unpublishRow: row });
        }
        else {
            this.setState({ publishModalIsOpen: true, publishRow: row });
        }

    }
    unpublishMeal = (event) => {
        event.preventDefault();
        editMenu.mealSummaryId = this.state.unpublishRow.id; //this.state.unpublishRow._links.self.href.split('/').pop();
        editMenu.schoolYear = sessionStorage.getItem('schoolYearValue');
        editMenu.loggedUser = sessionStorage.getItem('loggedUserName')

        let headers = {
            'Content-Type': 'application/json'
        };
        put(`/unpublishCalendar/${editMenu.mealSummaryId}?access_token=`, undefined, headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then((response) => {
            this.setState({ loading: true });
            if (response.statusCode === 200) {
                this.setState({ loading: false, unpublishModalIsOpen: false, unpublishRow: {} });
                _addNotification('Meal menu unpublished successfully.', this);
                this.loadData((new Date()).getFullYear());
                console.log('response', response);
            } else {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false, unpublishModalIsOpen: false, unpublishRow: {} });
                _addNotificationError(error.message, this);
                console.log('Meal Menu Creation Error', error)
            }
        );

    }

    publishMeal(event, publishWithReducedPriceZero = false) {
        event.preventDefault();
        editMenu.mealSummaryId = this.state.publishRow.id; //this.state.publishRow._links.self.href.split('/').pop();
        editMenu.isPublished = true;
        editMenu.schoolYear = sessionStorage.getItem('schoolYearValue');
        editMenu.loggedUser = sessionStorage.getItem('loggedUserName');
        if (publishWithReducedPriceZero) {
            editMenu.proceedWithoutReducedPrice = true;
        }

        let headers = {
            'Content-Type': 'application/json'
        };
        this.setState({ loading: true, reducedPriceLoading: true });
        postWithHeadersResponse(URL_VERSION + '/updateMealSummary?access_token=', JSON.stringify(editMenu), headers).then((response) => {

            if (response.statusCode === 200) {
                if (publishWithReducedPriceZero) {
                    this.setState({ loading: false, reducedPriceLoading: false, publishRow: {} });
                    this.hideReducedPriceModal();
                    _addNotification('Meal menu published successfully.', this);
                    this.loadData((new Date()).getFullYear());

                } else {
                    this.setState({ loading: false, publishModalIsOpen: false, publishRow: {} });
                    _addNotification('Meal menu published successfully.', this);
                    this.loadData((new Date()).getFullYear());
                }
            } else if (response.statusCode === 417) {
                this.setState({ publishModalIsOpen: false });
                this.showReducedPriceModal(this.state.publishRow);
            } else {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false, publishModalIsOpen: false, publishRow: {} });
                _addNotificationError(error.message, this);
                console.log('Meal Menu Creation Error', error)
            }
        );

    }
    hideReducedPriceModal = () => {
        this.setState({ reducedPriceModal: false, publishRow: undefined });
    }
    showReducedPriceModal = (rec) => {
        this.setState({ reducedPriceModal: true, publishRow: { ...rec } });
    }
    conformRegeneratePDF = (rec, type) => {
        this.setState({ regenPdfModelIsOpen: true, regenRecord: rec, mealType: type });
    }
    regenerateMealPDF = () => {
        let rec = this.state.regenRecord;
        const id = rec.id;
        if (this.state.mealType === MealTypes.LUNCH) {

            //rec._links.self.href.split('/').pop()
            get(URL_VERSION + '/refreshMenuPdf?summaryId=' + id + '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                console.log("Regenerate lunch pdf", data)
                this.setState({ regenPdfModelIsOpen: false, regenRecord: {} });
                _addNotification(data.statusMessage, this);
            }).catch(
                (error) => {
                    console.log('Get orderlist response', error)
                    _addNotificationError(error, this);
                }
            )
        } else {
            //rec._links.self.href.split('/').pop()
            get(URL_VERSION + '/refreshMenuPdf?summaryId=' + id + '&itemType=' + this.state.mealType.toUpperCase() + '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                console.log("Regenerate breakfast pdf", data)
                this.setState({ regenPdfModelIsOpen: false, regenRecord: {} });
                _addNotification(data.statusMessage, this);
            }).catch(
                (error) => {
                    console.log('Get orderlist response', error)
                    _addNotificationError(error, this);
                }
            )
        }
    }
    deleteMenu = (rec) => {
        this.setState({
            showDeleteModal: true,
            deleteRec: rec
        });
    }

    deleteMenuRecord = () => {
        let rec = this.state.deleteRec;
        const id = rec.id;
        _delete(`/schoolMonthlyCalendar/${id}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ showDeleteModal: false, deleteRec: {} });
            this.loadData((new Date()).getFullYear());
            _addNotification(data.statusMessage, this);

        }).catch(
            (error) => {
                console.log('Get orderlist response', error)
                _addNotificationError(error, this);
            }
        )
    }

    render() {
        const defaultExpandedRows = { 0: true, 1: true, 2: true, 3: true };
        gradeList = getSchoolGrades(0, false);
        const checkboxProps = {

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };

        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                        style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        //onRequestClose={() => this.setState({modalIsOpen: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row">
                            <button type="button" className="pull-right color-1" onClick={() => {
                                this.setState({ modalIsOpen: false })
                            }}>X</button>
                            <h3 style={{ color: '#0000b2' }} className="text-center">Cut-off Date</h3>
                            <form>
                                <div className="col-md-11">
                                    <CutoffDays mealObj={this.state} isWeekly={isWeekMenu(this.state.mealType)} {...this} onCutoffDateSubmit={(cutOffObj) => {
                                        this.handleUpdate(cutOffObj);
                                        // console.log(cutOffObj)
                                    }} />
                                </div>
                            </form>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.reducedPriceModal}
                        onRequestClose={() => this.hideReducedPriceModal()}
                        style={deleteStyles}
                        contentLabel="Publish">
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Reduced Price Confirmation</h4>
                        </div>
                        <div className="modal-body">
                            <p>Reduced Price not provided in school year setup.Do you want to set Reduced price as 0?</p>
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.hideReducedPriceModal()}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={(e) => this.publishMeal(e, true)}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                            </button>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={this.state.unpublishModalIsOpen}
                        onRequestClose={() => this.setState({ unpublishModalIsOpen: false, unpublishRow: {} })}
                        style={deleteStyles}
                        contentLabel="Publish">

                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Unpublish meal</h4>
                        </div>
                        <div className="modal-body">
                            <p>This action will cancel any existing orders for the items in this published menu . Do you still want to proceed with unpublish?</p>
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ unpublishModalIsOpen: false, unpublishRow: {} })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={this.unpublishMeal}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                            </button>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={this.state.publishModalIsOpen}
                        onRequestClose={() => this.setState({ publishModalIsOpen: false, publishRow: {} })}
                        style={deleteStyles}
                        contentLabel="Publish">

                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Publish meal</h4>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to publish meal menu?</p>
                            <p><b>Note: </b> Please review the menu items before publish and make sure that all items are on proper date. Once you publish, you can't edit the menu.</p>
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ publishModalIsOpen: false, publishRow: {} })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={this.publishMeal}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Publish
                            </button>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={this.state.regenPdfModelIsOpen}
                        onRequestClose={() => this.setState({ regenPdfModelIsOpen: false, regenRecord: {} })}
                        style={deleteStyles}
                        contentLabel="Publish" ariaHideApp={false}>

                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Regenerate Menu PDF</h4>
                        </div>
                        <div className="modal-body">
                            {
                                this.state.isLunch ? <p>Are you sure you want to regenerate lunch menu PDF?</p> :
                                    <p>Are you sure you want to regenerate breakfast menu PDF?</p>
                            }

                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ regenPdfModelIsOpen: false, regenRecord: {} })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={this.regenerateMealPDF}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Regenerate
                            </button>
                        </div>
                    </Modal>

                    <Modal
                        isOpen={this.state.showDeleteModal}
                        onRequestClose={() => this.setState({ showDeleteModal: false, deleteRec: {} })}
                        style={deleteStyles}
                        contentLabel="Publish" ariaHideApp={false}>

                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Delete Confirmation</h4>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this Menu?</p>
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ showDeleteModal: false, deleteRec: {} })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={() => this.deleteMenuRecord()}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Delete
                            </button>
                        </div>
                    </Modal>

                    <div className="container">
                        <div className="row">
                            <div className="sectionTitle">
                                <h2>
                                    <span>View Menu's for: {sessionStorage.getItem('schoolYear')}</span>
                                    <div style={{ display: 'inline-block', marginLeft: '50px' }}>
                                        <MenuOptions menuOptionsList={getMenuOptions()} onOptionSelect={(type) => {
                                            this.setState({ mealType: type }, () => {
                                                this.loadData('')
                                            })
                                            this.setState({ expanded: {} })
                                        }} selectedOption={(this.state.mealType)} />
                                    </div>
                                </h2>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="row">

                            <div className="panel panel-primary">
                                {/* <div class="col-md-12">
                                    {
                                        this.state.mealType == MealTypes.LUNCH ?
                                            <a href="javascript:void(0);" class="btn btn-success btn-lg pull-right" style={{
                                                margin: "10px 0px 10px 5px",
                                                fontSize: 14
                                            }} onClick={() => {
                                                this.edit_publishMenu({}, 'NEW', this.state.mealType);
                                            }}><i class="fa fa-plus"></i> Create Lunch Menu</a>
                                            : null}
                                    {
                                        this.state.mealType == MealTypes.BREAKFAST ?
                                            <a href="javascript:void(0);" class="btn btn-success btn-lg pull-right" style={{
                                                margin: "10px 0px 10px 5px",
                                                fontSize: 14
                                            }} onClick={() => {
                                                this.edit_publishMenu({}, 'NEW', this.state.mealType);
                                            }}><i class="fa fa-plus"></i> Create Breakfast Menu</a>
                                            : null}
                                    {
                                        this.state.mealType == MealTypes.SNACK ?
                                            <a href="javascript:void(0);" class="btn btn-success btn-lg pull-right" style={{
                                                margin: "10px 0px 10px 5px",
                                                fontSize: 14
                                            }} onClick={() => {
                                                this.edit_publishMenu({}, 'NEW', this.state.mealType);
                                            }}><i class="fa fa-plus"></i> Create Snacks Menu</a>
                                            : null}
                                    {
                                        this.state.mealType == MealTypes.DINNER ?
                                            <a href="javascript:void(0);" class="btn btn-success btn-lg pull-right" style={{
                                                margin: "10px 0px 10px 5px",
                                                fontSize: 14
                                            }} onClick={() => {
                                                this.edit_publishMenu({}, 'NEW', this.state.mealType);
                                            }}><i class="fa fa-plus"></i> Create Dinner Menu</a>
                                            : null}

                                </div> */}
                                <div className="panel-body">

                                    <ReactTable
                                        data={this.state.tableData}
                                        expanded={this.state.expanded}
                                        columns={[
                                            {
                                                Header: "Name",
                                                style: { textAlign: 'left' },
                                                accessor: "name"

                                            },
                                            {
                                                Header: "MONTH",
                                                style: { textAlign: 'center' },
                                                accessor: "month"

                                            },
                                            {
                                                Header: "GRADES",
                                                width: 200,
                                                style: { textAlign: 'center' },
                                                accessor: "grades"

                                            },
                                            {
                                                Header: "CUTOFF DATE",
                                                //accessor: "cutoff",                                                
                                                style: { textAlign: 'center' }, // className: "actions text-center"
                                                Cell: ({ row }) => (
                                                    <span>{
                                                        row._original.cutOffType == 'M' ?
                                                            <span>{row._original.cutoff ? moment(row._original.cutoff).format(date_format() + '  ' + 'hh:mm:ss a') : ''}&nbsp;&nbsp;
                                                            </span> : (row._original.cutOffType == 'W' ?
                                                                <span>{`${row._original.weeklyOrderCutOffDay} ${row._original.weeklyOrderCutOffTime ? moment(row._original.weeklyOrderCutOffTime, 'HH:mm:ss').format('hh:mm a') : ''}`} </span> :
                                                                <span>{`${(row._original.allowOrderNDaysBefore || 0) == -1 ? 'Same Day' : (row._original.allowOrderNDaysBefore || 0) + ' days'} & ${row._original.allowOrderNDaysTimeBefore ? moment(row._original.allowOrderNDaysTimeBefore, 'HH:mm:ss').format('hh:mm a') : ''}  before.`}</span>)
                                                    }<a title="Edit" href="javascript:void(0);"
                                                        onClick={() => {
                                                            this.openModal(row._original);
                                                        }} className="fa fa-pencil"><i /></a></span>)
                                            },
                                            {
                                                Header: "MENU PDF",
                                                accessor: "pdf",
                                                width: 100,
                                                style: { textAlign: 'center' },
                                                Cell: ({ row }) => (<div>
                                                    <a title="Click to Download PDF" href={row._original.pdf}
                                                        target='_blank'
                                                        className="fa fa-file-pdf-o fa-2x"><i /></a>
                                                    <a title="Click to Regenerate PDF" href="javascript:void(0);" onClick={() => {
                                                        this.conformRegeneratePDF(row._original, this.state.mealType);
                                                    }} style={{ padding: '7px', fontSize: '24px' }}  ><i className="fa fa-refresh"></i></a>
                                                </div>)
                                            },
                                            // {
                                            //     Header: "Edit",
                                            //     width: 100,
                                            //     accessor: "editMenu",
                                            //     style: { textAlign: 'center', width: '25px', },
                                            //     Cell: ({ row }) => (<div style={{ fontSize: '25px' }}>
                                            //         {row._original.isPublished == true ? <Fragment><a title="Click to edit menu." href="javascript:void(0);"
                                            //             style={{ pointerEvents: 'none', cursor: 'not-allowed', color: 'gray' }}
                                            //             onClick={() => {
                                            //                 this.edit_publishMenu(row._original, 'EDIT', this.state.mealType);
                                            //             }} className="fa fa-edit"><i /></a> &nbsp;
                                            //             <a title="Click to delete menu" href="javascript:void(0);"
                                            //                 onClick={() => {

                                            //                 }} className="fa fa-trash" style={{ pointerEvents: 'none', cursor: 'not-allowed', color: 'gray' }}><i /></a>
                                            //         </Fragment>

                                            //             :
                                            //             <Fragment> <a title="Click to edit menu." href="javascript:void(0);"
                                            //                 onClick={() => {
                                            //                     this.edit_publishMenu(row._original, 'EDIT', this.state.mealType);
                                            //                 }} className="fa fa-edit" style={{ color: '#19AB27' }}><i /></a> &nbsp;
                                            //                 <a title="Click to delete menu" href="javascript:void(0);"
                                            //                     onClick={() => {
                                            //                         this.deleteMenu(row._original);
                                            //                     }} className="fa fa-trash" style={{ color: '#19AB27' }}><i /></a>
                                            //             </Fragment>}
                                            //     </div>)
                                            // }, 
                                            {
                                                Header: "Publish",
                                                show: this.state.mealType === MealTypes.LUNCH ? getAccessLevelByModule(modEnum.LOM) : this.state.mealType === MealTypes.BREAKFAST ? getAccessLevelByModule(modEnum.BOM) : this.state.mealType === MealTypes.SNACK ? getAccessLevelByModule(modEnum.SOM) : this.state.mealType === MealTypes.DINNER ? getAccessLevelByModule(modEnum.DOM) : false,
                                                width: 100,
                                                accessor: "publish",
                                                style: { textAlign: 'center', width: '25px', },
                                                Cell: ({ row }) => (<div style={{ fontSize: '28px' }}>
                                                    {
                                                        (row._original.grades || '').length <= 0 ?
                                                            <a title="Grades are not selected to this menu." href="javascript:void(0);"
                                                                style={{ color: 'rgb(234, 112, 102)' }}
                                                                className="fa fa-info-circle"><i /></a>
                                                            :

                                                            (row._original.isPublished == true ? <a title="Click to unpublish menu" href="javascript:void(0);"
                                                                style={{ color: '#925ca5' }}
                                                                onClick={() => {
                                                                    this.edit_publishMenu(row._original, 'UNPUBLISH', this.state.mealType);
                                                                }} className="fa fa-cloud-download"><i /></a> :
                                                                <Fragment>
                                                                    <a title="Click to publish menu" href="javascript:void(0);"
                                                                        onClick={() => {
                                                                            this.edit_publishMenu(row._original, 'PUBLISH', this.state.mealType);
                                                                        }} className="fa fa-cloud-upload" style={{ color: '#19AB27' }}><i /></a>
                                                                </Fragment>)
                                                    }

                                                </div>)
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        className="-striped -highlight"
                                        {...checkboxProps}
                                        //defaultExpanded={defaultExpandedRows}
                                        onExpandedChange={expandedList => {
                                            const expanded = {}
                                            Object.keys(expandedList).forEach(item => {
                                                const expand = Boolean(expandedList[item] && expandedList[item].constructor === Object)
                                                expanded[item] = expand
                                            })
                                            this.setState({ expanded })
                                        }}
                                        SubComponent={row => {
                                            return (
                                                <div className="col-md-12">
                                                    <ManageMealItemCal row={{ ...row }} date={this.state.date} hiddenDays={getNotWorkingDays()}
                                                        type="MENU" mealType={this.state.mealType} callBackManageItems={this.callBackManageItems} notify={this} />
                                                    {/* {
                                                         row.original.isExtraPreOrder? */}
                                                    <Fragment>
                                                        <div className="sectionTitle">
                                                            <h2><span>EXTRA ITEMS</span></h2>
                                                        </div>
                                                        <ManageExtraItemCal row={{ ...row }} date={this.state.date} hiddenDays={getNotWorkingDays()}
                                                            type="MENU" mealType={this.state.mealType} callBackManageItems={this.callBackManageItems} notify={this} /></Fragment>
                                                    {/*  :null} */}
                                                </div>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

viewMenuV2.contextTypes = {
    router: PropTypes.object.isRequired
};

export default viewMenuV2;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/viewMenuV2.js